import { fetcher, SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';
import {
  TransactionFilterAllowedOptionsResponse,
} from './types';

export function useTransactionFilterOptions(
  corporationId: number,
  token?: string
) {
  const { data, error, isLoading, mutate } = useSWR<TransactionFilterAllowedOptionsResponse>(
    corporationId ? `new-sales-tax/transactions/filters/allowed-options?corporationId=${corporationId}` : null,
    SWRFetcher(
      {
        method: 'GET',
      },
      token
    )
  );

  const defaultData: TransactionFilterAllowedOptionsResponse = {
    data: {
      source_platforms: [],
      jurisdictions: [],
      countries: [],
      marketplaces: []
    },
    message: ''
  }

  return {
    data: data || defaultData,
    error,
    mutate,
    isLoading,
  };
}
